// Recovered compiled webpack factory 71239. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "normalizePathTrailingSlash", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }));
  let n = r(77700),
    a = r(5240),
    o = (e) => {
      if (!e.startsWith("/")) return e;
      let { pathname: t, query: r, hash: o } = (0, a.parsePath)(e);
      return "" + (0, n.removeTrailingSlash)(t) + r + o;
    };
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
